import React, { Component } from 'react';
import Inherit from '../../../core/inherit';
import InfiniteScrollController from './infiniteScroll.controller';
import styles from './styles/infinite-scroll.module.scss';

/**
 * Fires `onEndReached` when the user scrolls until the end of the scroll area
 * (viewport or `scrollRoot`). Uses a bottom sentinel + IntersectionObserver.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {() => void | Promise<void>} props.onEndReached
 * @param {boolean} [props.hasMore=true]
 * @param {boolean} [props.loading=false] — while true, callbacks are skipped
 * @param {boolean} [props.disabled=false]
 * @param {HTMLElement | null} [props.scrollRoot=null] — scrollable container; omit for window/viewport
 * @param {string} [props.rootMargin='0px 0px 240px 0px'] — expand root downward to prefetch before the literal end
 * @param {number} [props.initialDelayMs=0] — optional delay before observing (avoids eager load on short content)
 * @param {unknown} [props.resetKey] — when changed, re-applies initial delay if set
 * @param {string} [props.className]
 */
class InfiniteScroll extends Inherit(InfiniteScrollController, Component) {
    state = {
        ready: this.initialReadyFromProps(this.props)
    };
    sentinelRef = React.createRef();
    _observer = null;
    _readyTimer = null;
    _inFlight = false;

    render() {
        const { children, className = '' } = this.props;

        return (
            <div className={`${styles.wrap} ${className}`.trim()}>
                {children}
                <div ref={this.sentinelRef} className={styles.sentinel} aria-hidden />
            </div>
        );
    }
}

export default InfiniteScroll;
